export enum PaymentFrequencyEnum {
    YEARLY = 0,
    QUARTERLY,
    MONTHLY
}
